<style lang="scss">

</style>
<!--eslint-disable-->
<template>
  <div class="mx-auto" :style="{maxWidth: maxWidth}">
    <canvas :id="chartId" width="400" height="400"></canvas>
  </div>
</template>
<!--eslint-enable-->

<script>
  import Vue from 'vue';
  import Chart from 'chart.js';

  export default {
    components: {},
    props: {
      series: {
        type: Object,
        required: true,
      },
      chartId: {
        required: true,
        type: String,
      },
      maxWidth: {
        type: String,
        required: false,
      }
    },
    data() {
      return {
        chart: null,
      };
    },
    mounted() {
      this.setUpChart();
    },
    methods: {
      setUpChart() {
        Vue.nextTick(() => {
          let ctx = document.getElementById(this.chartId);

          // eslint-disable-next-line no-unused-vars
          let myChart = new Chart(ctx, {
            type: 'pie',
            data: {
              datasets: [{
                data: this.series.data,
                backgroundColor: [
                  '#845ec2',
                  '#d65db1',
                  '#ff6f91',
                  '#ff9671',
                  '#ffc75f',
                  '#f9f871',
                  '#2c73d2',
                  '#008e9b',
                  '#fbeaff',
                  '#00c9a7',
                  '#c34a36',
                  '#e1edf2'
                 ]
              }],
              labels: this.series.labels
            },
        });
        });
      }
    },
  };
</script>
